import { render } from "./SocialMediaAdAgencyPage.vue?vue&type=template&id=5e20cbaa&ts=true"
import script from "./SocialMediaAdAgencyPage.vue?vue&type=script&lang=ts"
export * from "./SocialMediaAdAgencyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__